// iCalendar output, in two flavours from one set of parts: a single event you
// download from a button, and the whole schedule as a feed people subscribe to
// once and then never think about again.

const pad = (number) => String(number).padStart(2, '0')

const asDate = (date) => `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`

const asTimestamp = (date) => [
  date.getUTCFullYear(), pad(date.getUTCMonth() + 1), pad(date.getUTCDate()), 'T',
  pad(date.getUTCHours()), pad(date.getUTCMinutes()), pad(date.getUTCSeconds()), 'Z'
].join('')

// Backslashes, semicolons, commas and newlines are all structural in iCalendar.
const escapeText = (text) => String(text)
  .replace(/\\/g, '\\\\')
  .replace(/([;,])/g, '\\$1')
  .replace(/\n/g, '\\n')

export const holidayEventTitle = (holiday) => (
  holiday.host ? `${holiday.name} - hosted by ${holiday.host}` : holiday.name
)

const eventLines = (holiday, now) => {
  const dayAfter = new Date(holiday.date.getFullYear(), holiday.date.getMonth(), holiday.date.getDate() + 1)

  return [
    'BEGIN:VEVENT',
    // Stable across rebuilds on purpose: a subscriber's calendar matches this
    // against what it already has, so a regenerated feed updates events in
    // place instead of piling up duplicates every deploy.
    `UID:${holiday.key}-${holiday.year}@grand.family`,
    `DTSTAMP:${asTimestamp(now)}`,
    // All-day, so it rides along the top of the day instead of claiming an hour.
    `DTSTART;VALUE=DATE:${asDate(holiday.date)}`,
    `DTEND;VALUE=DATE:${asDate(dayAfter)}`,
    `SUMMARY:${escapeText(holidayEventTitle(holiday))}`,
    'URL:https://grand.family',
    'END:VEVENT'
  ]
}

const wrapCalendar = (headerLines, bodyLines) => [
  'BEGIN:VCALENDAR',
  'VERSION:2.0',
  'PRODID:-//grand.family//Grand Holidays//EN',
  'CALSCALE:GREGORIAN',
  ...headerLines,
  ...bodyLines,
  'END:VCALENDAR'
].join('\r\n')

export const buildHolidayIcs = (holiday, now) => wrapCalendar([], eventLines(holiday, now))

// The subscribable version. Calendar apps re-fetch this on their own schedule,
// so adding a year to the rotation reaches everyone on the next deploy without
// anyone re-subscribing.
export const buildHolidayFeed = (holidays, now) => wrapCalendar(
  [
    'METHOD:PUBLISH',
    'X-WR-CALNAME:Grand Holidays',
    'X-WR-CALDESC:Who hosts Thanksgiving and Christmas Eve',
    'REFRESH-INTERVAL;VALUE=DURATION:P1D',
    'X-PUBLISHED-TTL:P1D'
  ],
  holidays.flatMap((holiday) => eventLines(holiday, now))
)

export const icsFileName = (holiday) => `${holiday.key}-${holiday.year}.ics`

export const downloadIcs = (holiday, now = new Date()) => {
  const blob = new Blob([buildHolidayIcs(holiday, now)], { type: 'text/calendar;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = icsFileName(holiday)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
